import locale, { setLocale } from './locale';
import toast, { removeToast, showToast } from './toast';
import channels from './channels';
import overview from './overview';
import oauth2 from './oauth2';
import CDRs from './CDRs';
import dashboard from './dashboard';

export const localeActions = {
  setLocale,
};

export const toastActions = {
  showToast,
  removeToast,
};

export const reducers = {
  locale,
  toast,
  oauth2,
  channels,
  overview,
  CDRs,
  dashboard,
};
